import { useHandleFetchError } from "../../../error-handler";
import { useGetCountries } from "../../../service/api";
import { getCountryInfo } from "../../../service/countries-service";
import { SelectInput } from "./SelectInput";

type Props = {
  name: string;
  onChange?: (value: any) => void;
  isDisabled?: boolean;
};

export const SelectCountryInput = ({ name, onChange, isDisabled }: Props) => {
  const { data: countries, error: getCountriesError } = useGetCountries();

  const countryOptions = (countries || [])
    .filter((c) => c.enabled)
    .sort((a, b) => a.countryCode.localeCompare(b.countryCode))
    .map((o) => ({
      label: `${getCountryInfo(o.countryCode).emojiFlag} ${o.englishName}`,
      value: o.countryCode,
    }));

  countryOptions.unshift({
    label: "None",
    value: "",
  });

  useHandleFetchError(getCountriesError);

  return (
    <SelectInput
      name={name}
      label="Country"
      options={countryOptions}
      placeholder="Choose country"
      onChange={onChange}
      isDisabled={isDisabled}
      helperText={
        isDisabled ? "You cannot change the country code." : undefined
      }
    />
  );
};
